import { useEffect, useState, memo, useContext, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import { toastifyError, toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from 'Context/Agency';
import { threeColVictimOffenseArray, offenseArray, } from '@/Components/Common/ChangeArrayFormat';
import { get_LocalStoreData } from '@/redux/api';
import { Decrypt_Id_Name, isLockOrRestrictModule, tableCustomStyle } from '@/Components/Common/Utility';
import NameListing from '@/Components/Pages/ShowAllList/NameListing';
import DataTable from 'react-data-table-component';
import { useNibrs } from '@/Context/NIBRS/NibrsLeftTreeContext';
import { useQuery } from 'react-query';
import NibrsServices from '@/CADServices/APIs/nibrs';

const DISABLED_OFFENSE_FBI_CODES = new Set([
  '720', '35A', '35B', '39A', '39B', '39C', '39D', '370',
  '40A', '40B', '40C', '520', '90B', '90C', '90D', '90F', '90G', '90J'
]);

const DISABLED_OFFENSE_FBI_CODES_FOR_NAMETYPE_2 = new Set([
  '13A', '13B', '13C', '09A', '09B', '64A', '64B', '100', '11A', '11B', '11C', '11D',
  '36A', '36B', '200', '510', '220', '250', '290', '270', '210',
  '26A', '26B', '26C', '26D', '26E', '26F', '26G',
  '23A', '23B', '23C', '23D', '23E', '23F', '23G', '23H',
  '120', '280'
]);

const Offense = (props) => {

  const { DecNameID, DecMasterNameID, DecIncID, ListData, isLocked } = props
  const dispatch = useDispatch();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
  const { nibrsLeftTreeErrorsData, refetchNibrsLeftTreeErrors } = useNibrs();
  const { get_Name_Count, setoffenceCountStatus, get_Data_Arrest, arrestFilterData } = useContext(AgencyContext);
  const [offenseDrp, setOffenseDrp] = useState();
  const [typeOfSecurityEditVal, setTypeOfSecurityEditVal] = useState();
  const [loginPinID, setLoginPinID,] = useState('');
  const [nameID, setNameID] = useState('');
  const [masterNameID, setmasterNameID] = useState('');
  const [incidentID, setIncidentID] = useState();
  const [multiSelected, setMultiSelected] = useState({ OffenseID: null, });
  const [selectedOffenses, setSelectedOffenses] = useState([]);
  const [nibrsVictimErrors, setNibrsVictimErrors] = useState([]);
  const [errorTooltip, setErrorTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setLoginPinID(localStoreData?.PINID);
    }
  }, [localStoreData]);

  useEffect(() => {
    if (DecNameID) {
      setNameID(DecNameID); setIncidentID(DecIncID);

    }
    else if (DecMasterNameID) {
      setmasterNameID(DecMasterNameID)
    }
  }, [DecNameID, loginPinID, DecMasterNameID]);


  useEffect(() => {
    if (DecNameID) {
      get_OffenseName_Data(DecNameID);
    }
  }, [DecNameID])

  useEffect(() => {
    if (incidentID) {
      get_Offense_DropDown(incidentID, DecNameID);
      get_Data_Arrest(incidentID, false, loginPinID);
    }
  }, [incidentID,])


  const getNIBRSVictimErrorsKey = `/NIBRS/GetNIBRSVictimErrors/${incidentID}`;
  const {
    data: nibrsVictimErrorsResponse,
    isSuccess: isNibrsVictimErrorsSuccess,
    refetch: refetchNibrsVictimErrors
  } = useQuery(
    [getNIBRSVictimErrorsKey, { IncidentId: incidentID, state: 'TX' },],
    NibrsServices.getNIBRSVictimErrors,
    {
      refetchOnWindowFocus: false,
      enabled: !!incidentID,
      retry: 0
    }
  );

  useEffect(() => {
    if (nibrsVictimErrorsResponse && isNibrsVictimErrorsSuccess) {
      const filteredVictimErrors = (nibrsVictimErrorsResponse?.data?.VictimErrors || []).filter((item) => {
        if (item?.ErrorCode !== "Error_478") return false;
        if (!item?.ContextJson) return false;

        try {
          const parsedContext = JSON.parse(item.ContextJson);
          return String(parsedContext?.name_id || '').trim() === String(DecNameID || '').trim();
        } catch (error) {
          console.error('Invalid ContextJson in victim errors filter', error);
          return false;
        }
      });

      setNibrsVictimErrors(filteredVictimErrors);
    } else {
      setNibrsVictimErrors([]);
    }
  }, [nibrsVictimErrorsResponse, isNibrsVictimErrorsSuccess, DecNameID]);


  const get_OffenseName_Data = (DecNameID) => {
    const val = { 'NameID': DecNameID, }
    fetchPostData('NameOffense/GetData_NameOffense', val).then((res) => {
      if (res) {
        setTypeOfSecurityEditVal(offenseArray(res, 'NameOffenseID', 'OffenseID', 'NameID', 'NameID', 'Offense_Description', 'PretendToBeID', '', 'FBICode'));
      } else {
        setTypeOfSecurityEditVal([]);
      }
    }).catch((err) => {
      console.error("🚀 ~ getOffenseData ~ err:", err);
    })
  }

  useEffect(() => {
    if (typeOfSecurityEditVal) {
      setMultiSelected(prevValues => { return { ...prevValues, OffenseID: typeOfSecurityEditVal } });
      // Update selectedOffenses to match typeOfSecurityEditVal
      // typeOfSecurityEditVal has: value = NameOffenseID, code = OffenseID
      // We need OffenseID (code) to match with offenseDrp.value (CrimeID/OffenseID)
      const selectedValues = typeOfSecurityEditVal.map(item => item.code);
      setSelectedOffenses(selectedValues);
    }
  }, [typeOfSecurityEditVal])

  const get_Offense_DropDown = (incidentID, nameID) => {
    const val = {
      'IncidentID': incidentID,
      'NameID': nameID,
      'MasterNameID': masterNameID,
      'IsMaster': nameID ? false : true
    }
    fetchPostData('NameOffense/GetData_InsertNameOffense', val).then((data) => {
      if (data) {
        setOffenseDrp(threeColVictimOffenseArray(data, 'CrimeID', 'Offense_Description', '', 'FBICode'))
      } else {
        setOffenseDrp([])
      }
    }).catch((err) => {
      console.error("🚀 ~ get_Offense_DropDown fetchpostdata error ~ err:", err);
    })
  }

  const InSertBasicInfo = (id, col1, url) => {
    const val = {
      'NameID': nameID,
      [col1]: id,
      'CreatedByUserFK': loginPinID,
      'MasterNameID': masterNameID,
      'IsMaster': nameID ? false : true
    }
    AddDeleteUpadate(url, val).then((res) => {
      if (res) {
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);
        refetchNibrsVictimErrors();
        refetchNibrsLeftTreeErrors();
        get_Name_Count(DecNameID)
        get_Offense_DropDown(incidentID, DecNameID);


        col1 === 'OffenseID' && get_OffenseName_Data(DecNameID);
      }
    }).catch((err) => {
      console.error("🚀 ~ Insert AddDeleteUpadate ~ err:", err);
    })
  }

  const DelSertBasicInfo = (OffenseID, col1, url) => {
    const val = {
      [col1]: OffenseID,
      'DeletedByUserFK': loginPinID,
    }
    AddDeleteUpadate(url, val).then((res) => {
      if (res) {
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);
        refetchNibrsLeftTreeErrors();
        refetchNibrsVictimErrors();
        get_Name_Count(DecNameID)
        get_Offense_DropDown(incidentID, DecNameID);

        col1 === 'NameOffenseID' && get_OffenseName_Data(DecNameID)
      }
    }).catch((err) => {
      console.error("🚀 ~ Delete AddDeleteUpadate ~ err:", err);
    })
  }


  // Handle checkbox change for DataTable
  const handleCheckboxChange = (offenseId, isChecked) => {
    if (isChecked) {
      // Add to selected offenses immediately to remove from table
      setSelectedOffenses(prev => {
        if (prev.includes(offenseId)) return prev; // Already selected
        return [...prev, offenseId];
      });
      // Call insert API
      InSertBasicInfo(offenseId, 'OffenseID', 'NameOffense/Insert_NameOffense');
      setoffenceCountStatus(true);
    } else {
      // When unchecking last offense - block if nameID has arrest in arrestFilterData
      if (selectedOffenses.length <= 1) {
        const nameHasArrest = arrestFilterData?.some(item => parseInt(item.ArresteeID) === parseInt(nameID));
        if (nameHasArrest) {
          toastifyError("At least one offense should be selected as it is associated with Arrest.");
          return;
        }
      }
      // Remove from selected offenses immediately to show in table
      setSelectedOffenses(prev => {
        const remaining = prev.filter(id => id !== offenseId);
        if (remaining.length === 0) {
          setoffenceCountStatus(false);
        }
        return remaining;
      });
      // Find the NameOffenseID from typeOfSecurityEditVal
      // typeOfSecurityEditVal has: value = NameOffenseID, code = OffenseID
      const offenseToDelete = typeOfSecurityEditVal?.find(item => item.code === offenseId);
      if (offenseToDelete) {
        DelSertBasicInfo(offenseToDelete.value, 'NameOffenseID', 'NameOffense/Delete_NameOffense');
      }
    }
  };

  // Combine offenseDrp with multiSelected offenses to show all offenses
  // Convert multiSelected.OffenseID items to match offenseDrp format
  const multiSelectedOffenses = (multiSelected?.OffenseID || []).map(item => ({
    value: item.code, // OffenseID
    label: item.label, // Offense_Description
    isFromMultiSelected: true,// Flag to identify source
    FBICode: item.FBICode // Flag to identify source
  }));

  // Merge offenseDrp and multiSelected offenses, removing duplicates
  const allOffenses = [...(offenseDrp || [])];
  multiSelectedOffenses.forEach(multiOffense => {
    // Check if offense already exists in offenseDrp
    const existingIndex = allOffenses.findIndex(off => off.value === multiOffense.value);
    if (existingIndex !== -1) {
      // Update existing item to mark it as from multiSelected
      allOffenses[existingIndex].isFromMultiSelected = true;
    } else {
      // Add new item from multiSelected
      allOffenses.push(multiOffense);
    }
  });

  // Sort: items with isFromMultiSelected=true at top, then alphabetically by label
  const sortedAllOffenses = allOffenses.sort((a, b) => {
    // First, prioritize items from multiSelected (isFromMultiSelected: true)
    if (a.isFromMultiSelected && !b.isFromMultiSelected) return -1;
    if (!a.isFromMultiSelected && b.isFromMultiSelected) return 1;

    // If both have same isFromMultiSelected status, sort alphabetically by label
    const labelA = a.label?.toLowerCase() || '';
    const labelB = b.label?.toLowerCase() || '';
    return labelA.localeCompare(labelB);
  });


  const victimErrorCrimeIds = useMemo(() => {
    const crimeIds = new Set();

    (nibrsVictimErrors || []).forEach((errorItem) => {
      if (!errorItem?.ContextJson) return;

      try {
        const parsedContext = JSON.parse(errorItem.ContextJson);
        const contextCrimeIds = parsedContext?.crime_ids || [];

        contextCrimeIds.forEach((crimeId) => {
          const normalizedCrimeId = String(crimeId || '').trim();
          if (normalizedCrimeId) {
            crimeIds.add(normalizedCrimeId);
          }
        });
      } catch (error) {
        console.error('Invalid ContextJson for victim error crime ids', error);
      }
    });

    return crimeIds;
  }, [nibrsVictimErrors]);

  const victimErrorMessagesByCrimeId = useMemo(() => {
    const messageMap = new Map();

    (nibrsVictimErrors || []).forEach((errorItem) => {
      if (!errorItem?.ContextJson) return;

      try {
        const parsedContext = JSON.parse(errorItem.ContextJson);
        const contextCrimeIds = parsedContext?.crime_ids || [];
        const messagePlain = String(errorItem?.MessagePlain || '').trim();
        if (!messagePlain) return;

        contextCrimeIds.forEach((crimeId) => {
          const normalizedCrimeId = String(crimeId || '').trim();
          if (!normalizedCrimeId) return;

          if (!messageMap.has(normalizedCrimeId)) {
            messageMap.set(normalizedCrimeId, new Set());
          }
          messageMap.get(normalizedCrimeId).add(messagePlain);
        });
      } catch (error) {
        console.error('Invalid ContextJson for victim error crime id messages', error);
      }
    });

    return messageMap;
  }, [nibrsVictimErrors]);


  // Define columns for DataTable
  const columns = [
    {
      name: '',
      width: '60px',
      cell: (row) => {
        const isModuleLocked = isLockOrRestrictModule("Lock", typeOfSecurityEditVal, isLocked, true);
        const isNameType2 = String(ListData?.[0]?.NameTypeID ?? '').trim() === '2';
        const normalizedFBICode = String(row?.FBICode || '').trim().toUpperCase();
        const isDisabledByFBICode = isNameType2
          ? DISABLED_OFFENSE_FBI_CODES_FOR_NAMETYPE_2.has(normalizedFBICode)
          : DISABLED_OFFENSE_FBI_CODES.has(normalizedFBICode);
        const isDisabled = isModuleLocked || isDisabledByFBICode;

        return (
          <input
            type="checkbox"
            checked={selectedOffenses.includes(row.value)}
            onChange={(e) => handleCheckboxChange(row.value, e.target.checked)}
            disabled={isDisabled}
            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
          />
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Offense',
      cell: (row) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>{row.label}</span>
          </div>
        );
      },
      sortable: true,
      wrap: true,
    },
    {
      name: 'TIBRS Code',
      selector: (row) => row.FBICode || '',
      sortable: true
    },
    {
      name: 'Error',
      selector: (row) => row.FBICode ? row.FBICode : '',
      sortable: true,
      cell: (row) => {
        if (!row?.isFromMultiSelected) {
          return null;
        }

        const crimeIdMessages = Array.from(
          victimErrorMessagesByCrimeId.get(String(row?.value || '').trim()) || []
        );
        const tooltipMessage = Array.from(new Set([...crimeIdMessages])).join(' | ');

        // Show MessagePlain tooltip when ContextJson crime_id matches row.CrimeID
        if (tooltipMessage) {
          return (
            <span
              style={{ position: 'relative' }}
              onMouseEnter={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const centerX = rect.left + (rect.width / 2);
                const safeX = Math.min(Math.max(centerX, 280), window.innerWidth - 280);
                setErrorTooltip({
                  visible: true,
                  text: tooltipMessage,
                  x: safeX,
                  y: rect.top,
                });
              }}
              onMouseLeave={() => setErrorTooltip({ visible: false, text: '', x: 0, y: 0 })}
            >
              <span style={{ color: 'red', textDecoration: 'underline', cursor: 'pointer' }}>
                Error
              </span>
            </span>
          );
        }
      },
    },
  ];

  const conditionalRowStyles = useMemo(
    () => [
      {
        when: (row) =>
          !!row?.isFromMultiSelected &&
          victimErrorCrimeIds.has(String(row?.value || '').trim()),
        style: {
          backgroundColor: 'rgb(255 202 194)'
        }
      }
    ],
    [victimErrorCrimeIds]
  );
  return (
    <>
      <NameListing {...{ ListData }} />
      <div className="col-12 " id='display-not-form'>
        <div className='row'>
          <label htmlFor="" className='label-name ' style={{ fontSize: "15px" }}>Please Select the Offense Associate with this Person</label>
        </div>
        <div className="alert alert-danger py-1 px-2 mb-1" style={{ maxWidth: 'max-content' }}>
          {ListData[0]?.NameTypeID === 2 ? <span className="text-danger"> <strong>Note:</strong> In the below selection, you can only select offenses categorized as Crime Against Society. Crime Against Person and Crime Against Property offenses should be restricted. To select Crime Against Person and Crime Against Property offenses, the Name must be created with the Name Type = Person.</span> : <span className="text-danger"> <strong>Note:</strong> In the below selection, you can only select offenses categorized as Crime Against Person and Crime Against Property. Crime Against Society offenses should be restricted. To select Crime Against Society offenses, the Name must be created with the Name Type = Business.</span>}
        </div>
        <div className="row  mt-2">
          <div className="col-12 mb-3" >
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <DataTable
                columns={columns}
                data={sortedAllOffenses}
                customStyles={{
                  ...tableCustomStyle,
                  tableWrapper: {
                    style: {
                      maxHeight: '300px',
                    },
                  },
                }}
                noDataComponent="No offenses available"
                dense
                highlightOnHover
                fixedHeader
                fixedHeaderScrollHeight="300px"
                conditionalRowStyles={conditionalRowStyles}
              />
            </div>
          </div>
        </div>
      </div>
      {errorTooltip.visible && (
        <div
          style={{
            position: 'fixed',
            left: `${errorTooltip.x}px`,
            top: `${errorTooltip.y - 12}px`,
            transform: 'translate(-50%, -100%)',
            zIndex: 99999,
            maxWidth: '560px',
            pointerEvents: 'none'
          }}
        >
          <div
            style={{
              background: '#ffecec',
              border: '2px solid #f44336',
              borderRadius: '6px',
              padding: '8px 12px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              color: '#f44336',
              fontSize: '14px',
              lineHeight: '20px',
              whiteSpace: 'normal',
              wordBreak: 'break-word'
            }}
          >
            <span style={{ display: 'block' }}>⚠️ {errorTooltip.text}</span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderTop: '12px solid #f44336'
            }}
          ></div>
        </div>
      )}
    </>
  )
}

export default memo(Offense)